export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20creative%20artistic%20abstract%20collage%20of%20fashion%20and%20streetwear%20elements%20including%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20artistically%20arranged%20in%20a%20soft%20pastel%20minimalist%20composition%20on%20a%20warm%20cream%20beige%20background%2C%20gentle%20watercolor%20texture%20overlay%2C%20dreamy%20editorial%20aesthetic%2C%20modern%20catalog%20style%2C%20warm%20neutral%20tones%20with%20subtle%20earthy%20accents%2C%20airy%20fresh%20atmosphere%2C%20no%20text%20no%20logos%20no%20branding&width=1600&height=900&seq=sugargoo-hero-bg-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion and streetwear product collage"
          title="Sugargoo Spreadsheet product finds and fashion categories"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-xs font-medium text-background-50">Updated Product Database</span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-3xl mx-auto leading-tight">
          The Ultimate <span className="text-primary-300">Sugargoo Spreadsheet</span> Database
        </h1>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
          Find thousands of updated Sugargoo products, verified shopping guides, shipping information, warehouse tips, discount codes and expert reviews — all in one place.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-flashlight-line text-lg"></i>
            Buy It Now
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8">
          {['Products Database', 'Shipping Guides', 'Real Reviews', 'Beginner Friendly'].map((badge) => (
            <div key={badge} className="flex items-center gap-1.5 text-background-50/70 text-xs">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}